"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _humps = _interopRequireDefault(require("humps"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var defaultAxiosConfig = {
  transformRequest: [function (data) {
    return _humps["default"].decamelizeKeys(data);
  }].concat(_toConsumableArray(_axios["default"].defaults.transformRequest)),
  transformResponse: [].concat(_toConsumableArray(_axios["default"].defaults.transformResponse), [function (data) {
    return _humps["default"].camelizeKeys(data);
  }])
};
var _default = defaultAxiosConfig;
exports["default"] = _default;